import { getAuthHeaders } from './auth-headers';
import { SUPABASE_FUNCTIONS_URL } from './config';

export type DaySnapshot = {
  date: string;
  impressions: number | null;
  reach: number | null;
  interactions: number | null;
  follower_delta: number | null;
  /** Подписчиков на конец месяца (из дневных снимков). */
  followers?: number | null;
};

export type AccountTimelineEntry = {
  username: string;
  avatar_url: string | null;
  days: DaySnapshot[];
};

export type TimelineResponse = {
  accounts: Record<string, AccountTimelineEntry>;
};

export async function fetchAccountTimeline(accountIds: string[]): Promise<TimelineResponse> {
  const headers = await getAuthHeaders();

  const response = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/timeline`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_ids: accountIds }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error((data as any).error || `Ошибка сервера: ${response.status}`);
  }

  return response.json();
}
